import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/DISCOUNTS/PRESETS';

export const {action: fetchAllPresets, success: fetchAllPresetsSuccess} = createAction(
    `${domain}/FETCH_ALL`,
    institutionId => ({institutionId}),
    (presets, behaviors) => ({presets, behaviors}),
);

export const {
    action: updatePresets,
    success: updatePresetsSuccess,
    failed: updatePresetsFailed,
} = createAction(
    `${domain}/UPDATE_ALL`,
    (institutionId, presets) => ({institutionId, presets}),
    presets => ({presets}),
);
